import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../../../hooks/hooks";
import PageLoader from "../../../../../../../../components/PageLoader";
import { selectProductInsightsListItems } from "../../../../../../../../redux/product-insights/selector";
import { productInsights } from "../../../../../../../../redux/product-insights/action";
import Table from "../../../../../../../../common/components/table";

const ManagementGatewayCockpitInsightsNPs = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const insightsNPItemsData = useSelector(selectProductInsightsListItems)
    const [columnDefs, setColumnDefs] = useState({});
    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'NPId', headerName: 'NP Id', searchField: 'NPId', sortable: true, filter: true, filterType: 'text' },
            { field: 'Name', headerName: 'Name', searchField: 'Name', sortable: true, filter: true, filterType: 'text' },
            { field: 'EdgeId', headerName: 'Edge Id', searchField: 'EdgeId', sortable: true, filter: true, filterType: 'text' },
            { field: 'TotalNoOfProviders', headerName: 'Total Providers', sortable: true, filter: true, filterType: 'text', callback: handleViewTotalProvidersDetails },
            { field: 'NoOfProvidersWithCompliance', headerName: 'Providers With Compliance', sortable: true, filter: true, filterType: 'text', callback: handleViewProvidersWithComplianceDetails },
            { field: 'NoOfProvidersWithoutCompliance', headerName: 'Providers Without Compliance', sortable: true, filter: true, filterType: 'text', callback: handleViewProvidersWithOutComplianceDetails },
            { field: 'NoOfProvidersPublishedToOpenNetwork', headerName: 'Providers Published To OpenNetwork', sortable: true, filter: true, filterType: 'text', callback: handleViewProvidersPublishedToOpenNetworkDetails },
            { field: 'NoOfProvidersNotPublishedToOpenNetwork', headerName: 'Providers Not Published To OpenNetwork', sortable: true, filter: true, filterType: 'text', callback: handleViewProvidersNotPublishedToOpenNetworkDetails },
            { field: 'NoOfProvidersPublishedToPartnerNetwork', headerName: 'Providers Published To PartnerNetwork', sortable: true, filter: true, filterType: 'text', callback: handleViewProvidersPublishedToPartnerNetworkDetails },
            { field: 'NoOfProvidersNotPublishedToPartnerNetwork', headerName: 'Providers Not Published To PartnerNetwork', sortable: true, filter: true, filterType: 'text', callback: handleViewProvidersNotPublishedToPartnerNetworkDetails },
        ]);
    }

    const handleViewList = (data: any) => {
        navigate(`/management/system/gateway-cockpit/insights/np/${data?.NPId}`)
    }

    const handleViewTotalProvidersDetails = async (data: any) => {
        navigate(`/management/system/gateway-cockpit?tab=Insights&subTab=Providers`, {
            state: {
                filters: [
                    {
                        "FieldName": "NPId",
                        "FilterOperatorId": 6,
                        "FieldValue": data?.NPId,
                        "FieldType": "number"
                    }
                ],
                title: "Providers"
            }
        })
    }

    const handleViewProvidersWithComplianceDetails = async (data: any) => {
        navigate(`/management/system/gateway-cockpit?tab=Insights&subTab=Providers`, {
            state: {
                filters: [
                    {
                        "FieldName": "NPId",
                        "FilterOperatorId": 6,
                        "FieldValue": data?.NPId,
                        "FieldType": "number"
                    },
                    {
                        "FieldName": "IsValidated",
                        "FilterOperatorId": 1,
                        "FieldValue": false,
                        "FieldType": "bool"
                    },
                ],
                title: "Providers With Compliance"
            }
        })
    }

    const handleViewProvidersWithOutComplianceDetails = async (data: any) => {
        navigate(`/management/system/gateway-cockpit?tab=Insights&subTab=Providers`, {
            state: {
                filters: [
                    {
                        "FieldName": "NPId",
                        "FilterOperatorId": 6,
                        "FieldValue": data?.NPId,
                        "FieldType": "number"
                    },
                    {
                        "FieldName": "IsValidated",
                        "FilterOperatorId": 1,
                        "FieldValue": true,
                        "FieldType": "bool"
                    },
                ],
                title: "Providers WithOut Compliance"
            }
        })
    }

    const handleViewProvidersPublishedToOpenNetworkDetails = async (data: any) => {
        navigate(`/management/system/gateway-cockpit?tab=Insights&subTab=Providers`, {
            state: {
                filters: [
                    {
                        "FieldName": "NPId",
                        "FilterOperatorId": 6,
                        "FieldValue": data?.NPId,
                        "FieldType": "number"
                    },
                    {
                        "FieldName": "IsPublishedInOpenNetwork",
                        "FilterOperatorId": 1,
                        "FieldValue": true,
                        "FieldType": "bool"
                    },
                ],
                title: "Providers Published To OpenNetwork"
            }
        })
    }

    const handleViewProvidersNotPublishedToOpenNetworkDetails = async (data: any) => {
        navigate(`/management/system/gateway-cockpit?tab=Insights&subTab=Providers`, {
            state: {
                filters: [
                    {
                        "FieldName": "NPId",
                        "FilterOperatorId": 6,
                        "FieldValue": data?.NPId,
                        "FieldType": "number"
                    },
                    {
                        "FieldName": "IsPublishedInOpenNetwork",
                        "FilterOperatorId": 1,
                        "FieldValue": false,
                        "FieldType": "bool"
                    },
                ],
                title: "Providers Not Published To OpenNetwork"
            }
        })
    }

    const handleViewProvidersPublishedToPartnerNetworkDetails = async (data: any) => {
        navigate(`/management/system/gateway-cockpit?tab=Insights&subTab=Providers`, {
            state: {
                filters: [
                    {
                        "FieldName": "NPId",
                        "FilterOperatorId": 6,
                        "FieldValue": data?.NPId,
                        "FieldType": "number"
                    },
                    {
                        "FieldName": "IsPublishedInPartnerNetwork",
                        "FilterOperatorId": 1,
                        "FieldValue": true,
                        "FieldType": "bool"
                    },
                ],
                title: "Providers Published To PartnerNetwork"
            }
        })
    }

    const handleViewProvidersNotPublishedToPartnerNetworkDetails = async (data: any) => {
        navigate(`/management/system/gateway-cockpit?tab=Insights&subTab=Providers`, {
            state: {
                filters: [
                    {
                        "FieldName": "NPId",
                        "FilterOperatorId": 6,
                        "FieldValue": data?.NPId,
                        "FieldType": "number"
                    },
                    {
                        "FieldName": "IsPublishedInPartnerNetwork",
                        "FilterOperatorId": 1,
                        "FieldValue": false,
                        "FieldType": "bool"
                    },
                ],
                title: "Providers Not Published To PartnerNetwork"
            }
        })
    }

    const additionButtons: any = [
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
                    <title>Reload this table</title>
                    <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>,
            // name: 'Reload',
            callback: () => handleReloadData(),
        },        
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
                    <title>Publish NP Insights</title>
                    <path d="M6.93745 10C6.24652 10.0051 5.83076 10.0263 5.4996 10.114C3.99238 10.5131 2.96048 11.8639 3.00111 13.3847C3.01288 13.8252 3.18057 14.3696 3.51595 15.4585C4.32309 18.079 5.67958 20.3539 8.7184 20.8997C9.27699 21 9.90556 21 11.1627 21L12.8372 21C14.0943 21 14.7229 21 15.2815 20.8997C18.3203 20.3539 19.6768 18.079 20.4839 15.4585C20.8193 14.3696 20.987 13.8252 20.9988 13.3847C21.0394 11.8639 20.0075 10.5131 18.5003 10.114C18.1691 10.0263 17.7534 10.0051 17.0625 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                    <path d="M12 3L12 14M12 3C12.4683 3 12.8243 3.4381 13.5364 4.3143L14.5 5.5M12 3C11.5316 3 11.1756 3.4381 10.4635 4.3143L9.49995 5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>,
            callback: () => handlePublishInsightsNPData(),
        },
    ];

    const fetchtGatewayCockpitInsightsNPList = async () => {
        await dispatch(productInsights.resetAction({ actionType: 'list' }));
        await dispatch(productInsights.list({
            url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/catalog-collections/insights/fetch`,
            entity: 'productInsights',
            jsonData:
            {
                "Context": {
                },
                "Records": [
                    {
                        "InsightsTypeId": 20
                    }
                ],
                "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "NPId",
                    "SortOrder": "asc"
                }
            }
        }))
    }

    useEffect(() => {
        createColumnDefs()
        fetchtGatewayCockpitInsightsNPList()
    }, [pageData, pageSize])

    const handleReloadData = () => {
        fetchtGatewayCockpitInsightsNPList();
    }
    
    const handlePublishInsightsNPData = async () => {
        await dispatch(productInsights.resetAction({ actionType: 'create' }))
        await dispatch(productInsights.create({
            url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/catalog-collections/insights/publish`,
            entity: 'productInsights',
            jsonData:
            {
                Context: {},
                Records: [
                    {
                        InsightTypeId: 20
                    }
                ]
            }
        })).then(() => {
            fetchtGatewayCockpitInsightsNPList()
        });
    }

    const handleSearch = async (data: any) => {
        let searchCriteria = {};
        if (data?.column) {
            searchCriteria = [{
                FieldName: data?.column,
                FieldText: data?.column,
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        } else {
            searchCriteria = [{
                FieldName: "Name",
                FieldText: "Name",
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        }
        await dispatch(productInsights.resetAction({ actionType: 'list' }));
        await dispatch(productInsights.list({
            url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/catalog-collections/insights/fetch`,
            entity: 'productInsights',
            jsonData: {
                "Context": {
                },
                "Records": [
                    {
                        "InsightsTypeId": 20
                    }
                ],
                "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "NPId",
                    "SortOrder": "asc",
                    "Searches": searchCriteria
                }
            }
        }));
    }

    const handleSelect = (data: any) => {
        // console.log("Item", data)
    }

    return (
        <>
            {insightsNPItemsData?.isLoading ? <PageLoader /> :
                <Table columnData={columnDefs}
                    rowData={insightsNPItemsData?.result?.items}
                    setPageData={setPageData} setPageSize={setPageSize}
                    enableFilter={true} onSearch={handleSearch} onSelect={handleSelect}
                    paginationData={insightsNPItemsData?.result?.pagination}
                    additionButtons={additionButtons} onViewList={handleViewList}
                    checkboxConfig={{
                        allowMultiSelect: true,
                        defaultSelectedIds: [],
                        isDisabled: false,
                        keyColumn: 'NPId',
                    }}
                    headingName="Network Participants"
                />
            }
        </>
    );
};

export default ManagementGatewayCockpitInsightsNPs;


